import React, { useRef, useEffect, useCallback } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const ScrollingGallery = ({ showLoader }) => {
    const scrollContainerRef = useRef(null);

    // Use useCallback for the scroll function to prevent unnecessary re-renders
    const handleScroll = useCallback(() => {
        const scrollContainer = scrollContainerRef?.current;
        const scrollContent = scrollContainer?.querySelector(".scroll-content");

        let scrollPos = 0;
        const scrollSpeed = 1; // Adjust the scrolling speed here

        const scroll = () => {
            scrollPos += scrollSpeed;

            if (scrollPos >= scrollContent?.offsetWidth - scrollContainer?.offsetWidth) {
                scrollPos = 0;
            }
            if (scrollContainer) {
                scrollContainer.scrollLeft = scrollPos;
            }
            requestAnimationFrame(scroll);
        };

        const animationFrameId = requestAnimationFrame(scroll);

        return () => {
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    useEffect(() => {
        const cleanup = handleScroll();
        return cleanup;
    }, [showLoader, handleScroll]);

    return (
        <div className="container-fluid" style={{ backgroundColor: "#fff" }}>
            <div className="row justify-content-center">
                <div className="col-md-12">
                    <div className="scroll-container" ref={scrollContainerRef}>
                        <div className="scrollwidth scroll-content">
                            <div className="homegrid">
                                <div className="homegrid1 maingrid">
                                    <LazyLoadImage 
                                        src={"https://colorbots3.s3.ap-south-1.amazonaws.com/Home-Page/Home-room-img1.webp"}
                                        className="img-fluid" 
                                        alt="Colorbot Helix Urban Oak Ceiling Fan in room"
                                        effect="blur"
                                    />
                                </div>
                                <div className="mainhomegrid">
                                    <div className="subhomegrid">
                                        <div className="homegrid1">
                                            <LazyLoadImage 
                                                src={"https://colorbots3.s3.ap-south-1.amazonaws.com/Home-Page/Home-room-img2.webp"}
                                                className="img-fluid" 
                                                alt="Colorbot Stella Cocoa Brown Ceiling Fan in room"
                                                effect="blur"
                                            />
                                        </div>
                                        <div className="homegrid1">
                                            <LazyLoadImage 
                                                src={"https://colorbots3.s3.ap-south-1.amazonaws.com/Home-Page/Home-room-img3.webp"}
                                                className="img-fluid" 
                                                alt="Colorbot Stella Urban Oak Ceiling Fan in room"
                                                effect="blur"
                                            />
                                        </div>
                                    </div>
                                    <div className="subhomegrid">
                                        <div className="homegrid1">
                                            <LazyLoadImage 
                                                src={"https://colorbots3.s3.ap-south-1.amazonaws.com/Home-Page/Home-room-img7.webp"}
                                                className="img-fluid" 
                                                alt="Colorbot Knoxx Urban Oak Ceiling Fan in room"
                                                effect="blur"
                                            />
                                        </div>
                                        <div className="homegrid1">
                                            <LazyLoadImage 
                                                src={"https://colorbots3.s3.ap-south-1.amazonaws.com/Home-Page/Home-room-img5.webp"}
                                                className="img-fluid" 
                                                alt="Colorbot Stella Charcoal Black Ceiling Fan in room"
                                                effect="blur"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="homegrid">
                                <div className="mainhomegrid">
                                    <div className="subhomegrid">
                                        <div className="homegrid1">
                                            <LazyLoadImage 
                                                src={"https://colorbots3.s3.ap-south-1.amazonaws.com/Home-Page/Home-room-img6.webp"}
                                                className="img-fluid" 
                                                alt="Colorbot Knoxx Midnight Grey Ceiling Fan in room"
                                                effect="blur"
                                            />
                                        </div>
                                        <div className="homegrid1">
                                            <LazyLoadImage 
                                                src={"https://colorbots3.s3.ap-south-1.amazonaws.com/Home-Page/Home-room-img8.webp"}
                                                className="img-fluid" 
                                                alt="Colorbot Stella Arctic White Ceiling Fan in room"
                                                effect="blur"
                                            />
                                        </div>
                                    </div>
                                    <div className="subhomegrid">
                                        <div className="homegrid1">
                                            <LazyLoadImage 
                                                src={"https://colorbots3.s3.ap-south-1.amazonaws.com/Home-Page/Home-room-img4.webp"}
                                                className="img-fluid" 
                                                alt="Colorbot Knoxx Urban Oak Ceiling Fan in room"
                                                effect="blur"
                                            />
                                        </div>
                                        <div className="homegrid1">
                                            <LazyLoadImage 
                                                src={"https://colorbots3.s3.ap-south-1.amazonaws.com/Home-Page/Home-room-img9.webp"}
                                                className="img-fluid" 
                                                alt="Colorbot Stella Urban Oak Ceiling Fan in room"
                                                effect="blur"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(ScrollingGallery);
